import { render, staticRenderFns } from "./Storytelling_import_Presentazione.vue?vue&type=template&id=30866aec&scoped=true&"
import script from "./Storytelling_import_Presentazione.vue?vue&type=script&setup=true&lang=js&"
export * from "./Storytelling_import_Presentazione.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Storytelling_import_Presentazione.vue?vue&type=style&index=0&id=30866aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30866aec",
  null
  
)

export default component.exports